import * as LucideIcons from "lucide-react";

export default function CategoryBadge({ category, size = "sm" }) {
  if (!category) return null;
  const Icon = LucideIcons[category.icon] || LucideIcons.Tag;
  const px = size === "sm" ? "px-2.5 py-1" : "px-3 py-1.5";
  const fs = size === "sm" ? "text-xs" : "text-sm";
  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${px} ${fs}`}
         style={{ background: `${category.color}15`, color: category.color, fontFamily: "'DM Sans', sans-serif" }}
         data-testid={`category-badge-${category.code}`}>
      <Icon size={size === "sm" ? 12 : 14} />
      <span>{category.label_fr}</span>
    </div>
  );
}
